<template>
  <div class="module_container">
    <table class="task-table">
      <thead>
        <tr>
          <th>任务名称</th>
          <th>创建时间</th>
          <th>状态</th>
          <th>操作</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="row in rows" :key="row._key">
          <td>
            <div class="cell_text" @click="handleClick(row)">{{ row.name }}</div>
          </td>
          <td>{{formatDate(row.created_at) }}</td>
          <td>
            <div class="flex" style="gap: 10px;">
              <div v-if="row.status=='Succeeded'" class="succeesded_box">成功</div>
              <div v-if="row.status=='Running'" class="warning_box">进行中</div>
              <div v-if="row.status=='Failed'" class="failed_box">失败</div>
              <el-popover v-if="row.status =='Failed'" placement="top-start" title="提示" width="200" trigger="hover">
                <!-- <p>数据异常，请联系管理员</p> -->
                <p>数据异常，请联系管理员
                  <br />
                  或者点击右侧反馈按钮提交工单，后续会有技术人员联系您
                </p>
                <template #reference>
                  <el-icon style="font-size: 12px;color: #999;">
                    <Warning />
                  </el-icon>
                </template>
              </el-popover>
            </div>
          </td>
          <td>
            <div class="download_btn" @click="downloadHandle(row)" v-if="row.status=='Succeeded'">
              <img src="./Frame.png" alt="">
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script setup>
  import { ref, watch, defineProps, defineEmits } from 'vue';
  import { useStore } from '@/Store/index.js';
  import { generate_report } from '@/api/index.js';
  const store = useStore();
  const emit = defineEmits(['selectData',]);
  const props = defineProps({
    tableData: { type: Array, default: () => [] },
    item_data: {
      type: Object
    }
  })

  const rows = ref([])
  const is_download = ref(false);// 是否下载

  const handle_mode = ref('html');// 处理模式
  const is_need_result = ref(true);// 是否需要结果

  const normalize = (arr) =>
    Array.isArray(arr) ? arr.map((r, i) => ({ _key: r.id ?? `${i}-${r.name ?? ''}`, ...r })) : []



  //"2025-08-19T08:49:04.000000Z" 写一个方法，只要年月日 2025-08-19
  const formatDate = (dateStr) => {
    const date = new Date(dateStr)
    const year = date.getFullYear()
    const month = (date.getMonth() + 1).toString().padStart(2, '0')
    const day = date.getDate().toString().padStart(2, '0')
    return `${year}-${month}-${day}`
  };

  /* const handleClick = (row) => {
    if (row.status == 'Succeeded') {
      emit('selectData', row);
    }
  }; */

  let lastClickTime = 0;

  const handleClick = (row) => {
    const now = Date.now();
    if (now - lastClickTime < 3000) {
      console.log("节流，三秒内不能重复点击");
      return;
    }
    lastClickTime = now;

    if (row.status === 'Succeeded') {
      emit('selectData', row);
    }
  };


  const downloadHandle = function (item) {//报告节点下载

    console.log("入围", item);

    if (item.status == "Succeeded") {
      let input_data = { [item.task_name]: item.id };

      console.log("瞎子啊", item);

      const params = {
        "parent_id": store.task_id,
        "app_id": store.app_id,
        "task_id": item.id,
        "input_data": input_data,
        "category_name": store.category_name,
        "handle_type": 'download',
        "handle_mode": handle_mode.value,
        "is_need_result": is_need_result.value,
        "task_name": props.item_data.process_report[0].task_name,
        "title": props.item_data.title
      };
      is_download.value = true;
      generate_report(params).then((result) => {
        if (result.status == '200' && result.message) {
          ElMessage.success(result.message);
          is_download.value = false;
        };
      }).catch((err) => {
        console.error(err);
        is_download.value = false;
      });
    } else {
      ElMessage.error('任务未成功！');
    };

  };

  watch(() => props.tableData, (val) => {
    rows.value = normalize(val)
  }, { immediate: true, deep: true })
</script>

<style scoped>
  .module_container {
    padding: 16px;
    background: #fff;
    border-radius: 8px;
    overflow-x: auto;
    max-height: 300px;
  }

  .task-table {
    width: 100%;
    border-collapse: collapse;
    /* 固定列宽，防止撑开 */
    table-layout: fixed;
  }

  .task-table th,
  .task-table td {
    padding: 8px 12px;
    text-align: left;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    /* 超出省略号 */
    border-bottom: 1px solid #e0e0e0;
  }

  .task-table th {
    background-color: #fafafa;
    font-weight: 600;
  }

  .cell_text {
    cursor: pointer;
    color: var(--el-color-primary);
    text-decoration: underline;
  }

  .download_btn {
    width: 32px;
    height: 32px;
    background-color: #757D8A12;
    border-radius: 50%;

    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;

    img {
      max-width: 100%;
      max-height: 100%;
      object-fit: contain;

    }
  }

  .succeesded_box {
    color: #67C23A;
  }

  .failed_box {
    color: #F56C6C;
  }

  .warning_box {
    color: #E6A23C;
  }
</style>